var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(-1191 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2962",
    "data-name": "Rectangle 2962",
    transform: "translate(1191 76)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar_Calendar",
    "data-name": "Calendar / Calendar",
    transform: "translate(1190 76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4,7.365H18.306M4,7.365v7.868a4.441,4.441,0,0,0,.195,1.884,1.788,1.788,0,0,0,.781.782,4.436,4.436,0,0,0,1.882.195h8.589a4.432,4.432,0,0,0,1.881-.195,1.79,1.79,0,0,0,.782-.782,4.432,4.432,0,0,0,.195-1.881V7.365M4,7.365V6.649a4.444,4.444,0,0,1,.195-1.885,1.787,1.787,0,0,1,.781-.781,4.444,4.444,0,0,1,1.885-.195h.715M18.306,7.365V6.647a4.436,4.436,0,0,0-.195-1.882,1.789,1.789,0,0,0-.782-.781,4.439,4.439,0,0,0-1.884-.195h-.715m0-1.788V3.788m0,0H7.576M7.576,2V3.788",
    fill: "none",
    stroke: "#a3a3a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bd2e35b5bc3ffdea4597125fef894eca.svg";
export { ForwardRef as ReactComponent };